export const validation = {
  name: 'Category name is Required',
  serviceTypeMax: 'Service type should be less than 100 words',
  enterCallingServiceName: 'Please enter calling service name',
};
